import * as Types from './api-client.types';
export * from './api-client.types';

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export * as VariableClient from './api-client/VariableClient';

export * as VariableQuery from './api-client/VariableQuery';



export * as UserClient from './api-client/UserClient';

export * as UserQuery from './api-client/UserQuery';



export * as TestApiClient from './api-client/TestApiClient';

export * as TestApiQuery from './api-client/TestApiQuery';



export * as TemplateClient from './api-client/TemplateClient';

export * as TemplateQuery from './api-client/TemplateQuery';



export * as SignerClient from './api-client/SignerClient';

export * as SignerQuery from './api-client/SignerQuery';



export * as SharePointWebhookClient from './api-client/SharePointWebhookClient';

export * as SharePointWebhookQuery from './api-client/SharePointWebhookQuery';



export * as SettingsClient from './api-client/SettingsClient';

export * as SettingsQuery from './api-client/SettingsQuery';



export * as RevisionClient from './api-client/RevisionClient';

export * as RevisionQuery from './api-client/RevisionQuery';



export * as ProjectTeamClient from './api-client/ProjectTeamClient';

export * as ProjectTeamQuery from './api-client/ProjectTeamQuery';



export * as ProjectClient from './api-client/ProjectClient';

export * as ProjectQuery from './api-client/ProjectQuery';



export * as ProjectSignerClient from './api-client/ProjectSignerClient';

export * as ProjectSignerQuery from './api-client/ProjectSignerQuery';



export * as ProjectRolesClient from './api-client/ProjectRolesClient';

export * as ProjectRolesQuery from './api-client/ProjectRolesQuery';



export * as LLMClient from './api-client/LLMClient';

export * as LLMQuery from './api-client/LLMQuery';



export * as ExternalEditingClient from './api-client/ExternalEditingClient';

export * as ExternalEditingQuery from './api-client/ExternalEditingQuery';



export * as EditingLockClient from './api-client/EditingLockClient';

export * as EditingLockQuery from './api-client/EditingLockQuery';



export * as DocumentClient from './api-client/DocumentClient';

export * as DocumentQuery from './api-client/DocumentQuery';



export * as DocumentUtilitiesClient from './api-client/DocumentUtilitiesClient';

export * as DocumentUtilitiesQuery from './api-client/DocumentUtilitiesQuery';



export * as DocumentSigningClient from './api-client/DocumentSigningClient';

export * as DocumentSigningQuery from './api-client/DocumentSigningQuery';



export * as DocumentExportClient from './api-client/DocumentExportClient';

export * as DocumentExportQuery from './api-client/DocumentExportQuery';



export * as CommentClient from './api-client/CommentClient';

export * as CommentQuery from './api-client/CommentQuery';



export * as SignUrlClient from './api-client/SignUrlClient';

export * as SignUrlQuery from './api-client/SignUrlQuery';



export * as TestDataClient from './api-client/TestDataClient';

export * as TestDataQuery from './api-client/TestDataQuery';



export * as VersionClient from './api-client/VersionClient';

export * as VersionQuery from './api-client/VersionQuery';





import { addResultTypeFactory } from './api-client/helpers';
export { setBaseUrl, getBaseUrl } from './api-client/helpers';
export { setAxiosFactory, getAxios } from './api-client/helpers';


//-----PersistorHydrator.File-----
import type { PersistedClient } from '@tanstack/react-query-persist-client';
import type { DehydratedState, QueryKey } from '@tanstack/react-query'
import { getResultTypeFactory } from './api-client/helpers';

/*
 * If you have Dates in QueryKeys (i.e. in request parameters), you need to deserialize them to Dates correctly
 * (otherwise they are deserialized as strings by default, and your queries are broken).
 */
export function deserializeDate(str: unknown) {
  if (!str || typeof str !== 'string') return str;
  if (!/^\d\d\d\d\-\d\d\-\d\d/.test(str)) return str;
  
  const date = new Date(str);
  const isDate = date instanceof Date && !isNaN(date as any);
  
  return isDate ? date : str;
}

export function deserializeDatesInQueryKeys(queryKey: QueryKey) {
  return queryKey
    // We need to replace `null` with `undefined` in query key, because
    // `undefined` is serialized as `null`.
    // And most probably if we have `null` in QueryKey it actually means `undefined`.
    // We can't keep nulls, because they have a different meaning, and e.g. boolean parameters are not allowed to be null.
    .map(x => (x === null ? undefined : x))
    .map(x => deserializeDate(x));
}

export function deserializeClassesInQueryData(queryKey: QueryKey, data: any) {
  if (!data) {
    return data;
  } else if (typeof data !== 'object') {
    return data;
  } else if ('pages' in data && 'pageParams' in data && Array.isArray(data.pages) && Array.isArray(data.pageParams)) {
    // infinite query
    data.pages = data.pages.map((page:any) => deserializeClassesInQueryData(queryKey, page));
  } else if (Array.isArray(data)) {
    return data.map(elem => constructDtoClass(queryKey, elem));
  } else {
    return constructDtoClass(queryKey, data);
  }
}

/*
 * Pass this function as `deserialize` option to createSyncStoragePersister/createAsyncStoragePersister
 * to correctly deserialize your DTOs (including Dates)
 */
export function persisterDeserialize(cache: string): PersistedClient {
  const client: PersistedClient = JSON.parse(cache);
  client.clientState.queries.forEach((query) => {
    query.state.data = deserializeClassesInQueryData(query.queryKey, query.state.data);
    query.queryKey = deserializeDatesInQueryKeys(query.queryKey);
  });

  return client;
}

export function constructDtoClass(queryKey: QueryKey, data: any): unknown {
  const resultTypeKey = getResultTypeClassKey(queryKey);
  const constructorFunction = getResultTypeFactory(resultTypeKey);

  if (!data || !constructorFunction)
    return data;

  return constructorFunction(data);
}

export function getResultTypeClassKey(queryKey: QueryKey): string {
  if (!Array.isArray(queryKey)) {
    return queryKey as unknown as string;
  }
  if (queryKey.length >= 2) {
    // We concatenate first and second elements, because they uniquely identify the query.
    // All other QueryKey elements are query parameters
    return `${queryKey[0]}___${queryKey[1]}`;
  }

  // We actually should never reach this point :)
  return queryKey.join('___');
}

export function initPersister() {
  
  addResultTypeFactory('VariableClient___search', (data: any) => Types.initPagedResultOfVariableListItemDto(data));
  addResultTypeFactory('VariableClient___get', (data: any) => Types.initVariableDto(data));


  addResultTypeFactory('UserClient___getCurrentUserInfo', (data: any) => Types.initCurrentUserDto(data));




  addResultTypeFactory('TemplateClient___get', (data: any) => Types.initTemplateDto(data));
  addResultTypeFactory('TemplateClient___getVersionHistory', (data: any) => Types.initTemplateVersionHistoryItemDto(data));
  addResultTypeFactory('TemplateClient___search', (data: any) => Types.initPagedResultOfTemplateListItemDto(data));
  addResultTypeFactory('TemplateClient___getFolders', (data: any) => Types.initProjectElement(data));


  addResultTypeFactory('SignerClient___search', (data: any) => Types.initPagedResultOfSignerDto(data));
  addResultTypeFactory('SignerClient___get', (data: any) => Types.initSignerDto(data));




  addResultTypeFactory('SettingsClient___settingsDto', (data: any) => Types.initSettingsDto(data));
  addResultTypeFactory('SettingsClient___settingsForSpecificRevision', (data: any) => Types.initSettingsDto(data));


  addResultTypeFactory('RevisionClient___search', (data: any) => Types.initPagedResultOfRevisionListItemDto(data));
  addResultTypeFactory('RevisionClient___get', (data: any) => Types.initRevisionDto(data));


  addResultTypeFactory('ProjectTeamClient___getAvailableTeamMembers', (data: any) => Types.initSearchTeamMemberResultDto(data));


  addResultTypeFactory('ProjectClient___search', (data: any) => Types.initPagedResultOfProjectListItemDto(data));
  addResultTypeFactory('ProjectClient___get', (data: any) => Types.initProjectDto(data));


  addResultTypeFactory('ProjectSignerClient___search', (data: any) => Types.initPagedResultOfProjectSignerDto(data));
  addResultTypeFactory('ProjectSignerClient___get', (data: any) => Types.initProjectSignerDto(data));


  addResultTypeFactory('ProjectRolesClient___search', (data: any) => Types.initPagedResultOfProjectRoleDto(data));
  addResultTypeFactory('ProjectRolesClient___get', (data: any) => Types.initProjectRoleDto(data));






  addResultTypeFactory('EditingLockClient___checkLock', (data: any) => Types.initRefDocumentEditingUserDto(data));


  addResultTypeFactory('DocumentClient___get', (data: any) => Types.initDocumentDto(data));
  addResultTypeFactory('DocumentClient___search', (data: any) => Types.initPagedResultOfDocumentListItemDto(data));




  addResultTypeFactory('DocumentSigningClient___getDocumentSignersAvailableRoles', (data: any) => Types.initAvailableRolesDto(data));
  addResultTypeFactory('DocumentSigningClient___getDocumentsSigningStatus', (data: any) => Types.initDocumentSigningStatusDto(data));
  addResultTypeFactory('DocumentSigningClient___getSignerToResendNotifications', (data: any) => Types.initSignerToResendNotificationDto(data));




  addResultTypeFactory('CommentClient___get', (data: any) => Types.initCommentDto(data));
  addResultTypeFactory('CommentClient___search', (data: any) => Types.initPagedResultOfCommentListItemDto(data));








}
//-----/PersistorHydrator.File----